import React  from 'react';
import PropTypes from "prop-types";
import WidgetGallery from '../../../js/sabre/shs-widgets-gallery'
import '../../../js/sabre/shs-widgets-gallery/dist/index.css';
// import WidgetGallery from '@sabre/shs-widgets-gallery';
// import '@sabre/shs-widgets-gallery/dist/index.css'


// import ReactDOM from 'react-dom';

function Gallery({api, images, imageWidth, allowFullScreenZoom}) {
     return(
         <WidgetGallery api={api} images={images} imageWidth={imageWidth} allowFullScreenZoom={allowFullScreenZoom}></WidgetGallery>
     )
} 
  
  Gallery.propTypes = {
     api: PropTypes.string,
     socialShareUrl: PropTypes.string,
     socialShareTitle: PropTypes.string,
     allowFullScreenZoom:PropTypes.bool,
    // filtered: array.isRequired,
    // setHasHotels: func
    imageWidth: PropTypes.number,
    images: PropTypes.arrayOf(
        PropTypes.shape({
            img: PropTypes.string.isRequired,
            imgFull: PropTypes.string.isRequired,
            video: PropTypes.string,
            title: PropTypes.string,
            subTitle: PropTypes.string,
            description: PropTypes.string,
            category: PropTypes.string,
            socialConfig: PropTypes.shape({
                socialShareHashTag: PropTypes.array,
                socialShareTitle: PropTypes.string,
                socialShareUrl: PropTypes.string,
                socialShareBody: PropTypes.string
            }),
            variants: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    imgFull: PropTypes.string.isRequired,
                    video: PropTypes.string,
                    title: PropTypes.string,
                    subTitle: PropTypes.string,
                    description: PropTypes.string,
                    socialConfig: PropTypes.shape({
                        socialShareHashTag: PropTypes.array,
                        socialShareTitle: PropTypes.string,
                        socialShareUrl: PropTypes.string,
                        socialShareBody: PropTypes.string
                    }),
                    controls: PropTypes.arrayOf(
                        PropTypes.shape({
                            type: PropTypes.oneOf(["button", "price"]),
                            onClick: PropTypes.oneOfType([
                                PropTypes.string,
                                PropTypes.func
                            ]),
                            label: PropTypes.string,
                            className: PropTypes.string,
                            style: PropTypes.object,
                            props: PropTypes.object
                        })
                    )
                })
            ),
            controls: PropTypes.arrayOf(
                PropTypes.shape({
                    type: PropTypes.oneOf(["button", "price"]),
                    onClick: PropTypes.oneOfType([
                                PropTypes.string,
                                PropTypes.func
                            ]),
                    // if button it will be button label
                    label: PropTypes.string,
                    className: PropTypes.string,
                    style: PropTypes.object,
                    // if price it requires best price widget props i.e. {"type":"price","props":{"hotel":"10155","chain":"12011","room":"DLXK","labelSlogan":"Rates from","labelSlogan2":""}}
                    props: PropTypes.object,
                })
            )
        })
    ).isRequired
  };
  
  Gallery.defaultProps = {
    // destinationMap: true,
  }
  
  export default Gallery;
  


